'use client';

import Script from 'next/script';
import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { useExternalServiceStore } from '@/stores/externalServiceStore';

/**
 * Component in charge of conditionally loading the recaptcha script
 */
export const Recaptcha: FC = () => {
  const { setRecaptchaReady, shouldLoadRecaptcha } = useExternalServiceStore(
    ({ setRecaptchaReady, shouldLoadRecaptcha }) => ({ setRecaptchaReady, shouldLoadRecaptcha }),
    shallow,
  );

  if (!shouldLoadRecaptcha) {
    return null;
  }

  return (
    <Script
      id="recaptcha"
      key="recaptcha"
      data-testid="recaptcha-script"
      src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN}`}
      onLoad={() => {
        setRecaptchaReady(true);
      }}
    />
  );
};
